<template>
  <div class="home">
    <article class="m-5 p-5" v-for="article in filterByKey" :key="article.id">
      <b-card
        no-body
        class="overflow-hidden"
        style="max-width: 540px"
        @click="routerToArticle(article.id)"
      >
        <b-row no-gutters>
          <b-col md="6">
            <b-card-img :src="article.cover" alt="Image" class="rounded-0"></b-card-img>
          </b-col>
          <b-col md="6">
            <b-card-body :title="article.title">
              <time :datetime="article.date">{{ article.date | timeFilter }}</time> <b-badge pill variant="secondary">{{ article.tag }}</b-badge>
              <b-card-text align="left" v-html="article.abstract"></b-card-text>
            </b-card-body>
          </b-col>
        </b-row>
      </b-card>

      <!-- <h3>{{ article.title }}</h3>
      <time :datetime="article.date">{{ article.date | timeFilter }}</time>
      <p v-html="article.abstract" class="text-left"></p>-->
    </article>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";

export default {
  name: "Home",
  data() {
    return {};
  },
  computed: {
    ...mapState(["articles"]),
    ...mapGetters(["filterByKey"])
  },
  methods: {
    routerToArticle(id) {
      this.$router.push({ name: "Article", params: { id: id } });
    }
  }
};
</script>

// <style lang="scss" scoped>
// article {
//   width: 80%;
//   max-width: 1000px;
//   display: flex;
//   flex-direction: column;
//   align-items: flex-start;
//   background-color: #f0f0f0;
//   border-radius: 2rem;
//   cursor: pointer;
//   time {
//     color: #808080;
//   }
// }
//
</style>